// components/TestRunner/rules/Rule06a_SOR_NamingStandard_Success.js
import { Rule06_SOR_NamingStandard_Shared } from "./Rule06_SOR_NamingStandard_Shared.js";

/**
 * Rule06a_SOR_NamingStandard_Success.js
 *
 * ✅ Règle 06a – Les fichiers SOR de fibres en réussite doivent respecter le standard de nommage technique
 * Type: Error
 *
 * 🧪 Tests effectués :
 * • Contrôle RuleUtils.parseSorFileName() pour extraction des éléments
 * • Validation extension .sor et séparateur _OE_
 * • Validation préfixe contre fiber.ropRef.PBO_VALUE avec conversion de format
 * • Validation position B2-T[X]-M[Y]-[ZZZ]
 * • Validation longueur d'onde 1310nm ou 1550nm
 * • Validation numéro de tentative optionnel -[chiffre] ou _[chiffre]
 */

export class Rule06a_SOR_NamingStandard_Success {
  /**
   * Appliquer la règle 06a : Standard de nommage SOR pour réussite
   * @param {Object} fiber - Objet fibre avec toutes ses données
   */
  static apply(fiber) {
    // Prérequis : Rule00 + Rule01 + Rule03 ont validé l'existence des données de base
    // Vérifier qu'on est dans un cas de PV réussite
    if (!fiber.hasPvReussite) {
      return; // Règle ne s'applique qu'aux fibres avec PV réussite
    }

    // Déléguer la validation à la classe partagée avec le préfixe SRO-BPI
    const errorMessages = Rule06_SOR_NamingStandard_Shared.validateFiles(fiber.pvReussite.files, fiber, "R06a");

    // Ajouter les erreurs au résultat de la fibre
    errorMessages.forEach((errorMessage) => {
      this._addError(fiber, errorMessage.rule, errorMessage.title, errorMessage.message);
    });
  }

  /**
   * Ajouter une erreur au résultat d'une fibre
   */
  static _addError(fiber, rule, title, message) {
    if (!fiber.testResults) {
      fiber.testResults = {
        status: "success",
        hasError: false,
        messages: [],
      };
    }

    fiber.testResults.status = "error";
    fiber.testResults.hasError = true;
    fiber.testResults.messages.push({
      type: "error",
      rule,
      title,
      message,
    });
  }
}
